import React, { useCallback, useState } from 'react'
import { Box, Flex } from '@chakra-ui/react'
import { isYoutubeURL } from './validation'
import YouTube from 'react-youtube'
import PaginationCircle from '@components/pagination-circle'

interface PropsType {
  links: string[]
}

export const Video = ({
  link,
  opts
}: {
  link: string
  opts?: { [key: string]: any }
}) => {
  if (isYoutubeURL(link)) {
    const videoId = link.split('v=')[1]
    return (
      <Box
        w="100%"
        style={{
          aspectRatio: '16/9'
        }}
        sx={{
          iframe: {
            width: '100%',
            height: '100%'
          }
        }}
      >
        <YouTube
          videoId={videoId}
          style={{ width: '100%', height: '100%' }}
          opts={opts}
        />
      </Box>
    )
  }
  return (
    <Box
      w="100%"
      style={{
        aspectRatio: '16/9'
      }}
    >
      <video
        src={link}
        controls
        style={{ width: '100%', height: '100%', maxWidth: '100%' }}
      >
        <source src={link} type="video/mp4" />
        <source src={link} type="video/ogg" />
      </video>
    </Box>
  )
}

const VideoProduct = ({ links }: PropsType) => {
  const [page, setPage] = useState<number>(1)

  return (
    <Box w={'100%'} my={20}>
      <Flex w={'100%'} justifyContent={'center'}>
        <Box w="100%">
          {links[page - 1] && (
            <Video link={links[page - 1] || ''} opts={{ maxWidth: '100%' }} />
          )}
          <PaginationCircle
            length={links?.length || 0}
            page={page}
            onClick={(n: number) => {
              setPage(n)
            }}
          />
        </Box>
      </Flex>
    </Box>
  )
}

export default VideoProduct
